import { render, staticRenderFns } from "./OrdenCompraMateriales.vue?vue&type=template&id=44860596&"
import script from "./OrdenCompraMateriales.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraMateriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports